(function () {
  const TARGET_SELECTOR = '.cert-intel-paywall-stack, [data-cert-intel-overlay]';
  const WIDTH_DELTA_PX = 2;
  const ORIENTATION_SETTLE_MS = 150;

  let lastWidth = window.innerWidth;

  function measureViewportPx() {
    const vv = window.visualViewport;
    const raw = vv && Number.isFinite(vv.height) ? vv.height : window.innerHeight;
    return Math.max(1, Math.round(raw));
  }

  function lockDockViewport() {
    const viewportPx = measureViewportPx();
    const dockPx = Math.max(1, Math.round(viewportPx * 0.33));
    document.querySelectorAll(TARGET_SELECTOR).forEach(function (el) {
      el.style.setProperty('--cert-intel-viewport', viewportPx + 'px');
      el.style.setProperty('--cert-intel-dock-height', dockPx + 'px');
    });
  }

  function onResize() {
    const width = window.innerWidth;
    if (Math.abs(width - lastWidth) < WIDTH_DELTA_PX) return;
    lastWidth = width;
    lockDockViewport();
  }

  function onOrientationChange() {
    lastWidth = window.innerWidth;
    window.setTimeout(function () {
      lastWidth = window.innerWidth;
      lockDockViewport();
    }, ORIENTATION_SETTLE_MS);
  }

  function init() {
    lockDockViewport();
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onOrientationChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
